import { useState } from "react";
import { Section } from "../ui/Section";
import { Eyebrow } from "../ui/Eyebrow";
import { H2, Highlight } from "../ui/Heading";
import { ChatThread } from "../chat/ChatThread";
import { INTEGRATIONS, type IntegrationName } from "../data/integrations";
import { IntegrationTabs } from "./IntegrationTabs";
import { IntegrationDetail } from "./IntegrationDetail";

export function Integrations() {
  const [tab, setTab] = useState<IntegrationName>("HubSpot");
  const current = INTEGRATIONS[tab];

  return (
    <Section id="integrations">
      <Eyebrow n="05">Integrations</Eyebrow>
      <H2>
        Plugged into <Highlight>everything you already use</Highlight>.
      </H2>
      <p className="mt-4.5 max-w-[720px] text-[19px] text-td-2">
        Sidestack works the tools your team already lives in. Each one comes
        with everything your assistant would need to actually be useful — and
        you stay in control of what it can touch.
      </p>

      <IntegrationTabs current={tab} onSelect={setTab} />

      <div className="mt-9 grid grid-cols-[1.1fr_1fr] gap-12 items-start max-md:grid-cols-1 max-md:gap-9">
        <IntegrationDetail name={tab} integration={current} />
        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-accent mb-3.5">
            How it shows up in chat
          </div>
          <ChatThread key={tab} messages={current.msgs} height={460} />
        </div>
      </div>
    </Section>
  );
}
